<template>
  <div
    class="content-wrapper"
  >
    <multiselect
      v-model="selectedNavItem.subItems"
      :options="filteredOptions"
      :group-select="false"
      group-label="category"
      group-values="items"
      label="name"
      track-by="name"
      placeholder="Select items..."
      :multiple="true"
      :searchable="true"
      :close-on-select="false"
      :clear-on-select="false"
      :show-labels="false"
      :preserve-search="true"
      :preselect-first="true"
      @select="handleSelect"
    >
      <template #selection="{ values, isOpen }">
        <span 
          v-if="values.length && !isOpen"
          class="multiselect__single"   
        >
          {{ values.length }} options selected
        </span>
      </template>
      <template #option="{ option }">
        <span v-if="option.$isLabel">
          {{ option.$groupLabel }} 
        </span>
        <div class="custom-option">
          <span :class="['badge', option.type]" />
          {{ option.name }}
        </div>
      </template>
    </multiselect>
    <div
      v-if="selectedNavItem.subItems"
      class="sub-items-list"
    >
      <draggable
        :list="selectedNavItem.subItems"
        class="content__wrapper"
        @end="reorder"
      >
        <div
          v-for="item in selectedNavItem.subItems"
          :key="item.id"
        >
          <sub-item
            :sub-item="item"
            :editable="selectedNavItem.editable"
          />
        </div>
      </draggable>
    </div>
    <div class="legend">
      <div class="legend-item">
        <span class="badge M" /> Module
      </div>
      <div class="legend-item">
        <span class="badge F" /> Folder
      </div>
      <div class="legend-item">
        <span class="badge E" /> Entity
      </div>
      <div class="legend-item">
        <span class="badge P" /> Path
      </div>
    </div>
  </div>
</template>
<script>

import {createNamespacedHelpers} from 'vuex';
import SubItem from './SubItem.vue';
import {v4 as uuidv4} from 'uuid';
import { ADD_SUB_ITEM } from '@/store/modules/left-nav-customization/mutation-types';
import Draggable from 'vuedraggable';

const {
  mapMutations,
  mapState: LeftNavCustomizationMapState,
} = createNamespacedHelpers('leftNavCustomization');
const {mapState: sidebarMapState} = createNamespacedHelpers('sidebar');

export default {
  name: 'SubItemList',
  components: {
    SubItem,
    Draggable,
  },
  computed: {
    ...sidebarMapState({
      entities: state => state.tablesList,
      folders: state => state.foldersList,
      modules: state => state.modulesList,
      systemModules: state => state.moduleConfiguration,
    }),
    ...LeftNavCustomizationMapState({
      selectedNavItem: state => state.selectedNavItem,
    }),
    filteredOptions() {
      return [
        {category: 'Modules', items: this.filterSelected(this.objectToArray(this.modules, 'M'))},
        {category: 'Folders', items: this.filterSelected(this.objectToArray(this.folders, 'F'))},
        {category: 'Entities', items: this.filterSelected(this.objectToArray(this.entities, 'E'))},
      ];
    },
  },
  methods: {
    ...mapMutations({
      addSubItem: ADD_SUB_ITEM,
    }),
    objectToArray(obj, type) {
      return Object.keys(obj).map((key) => ({
        id: key,
        name: obj[key].label,
        type,
        parentId: this.selectedNavItem.id,
        moduleGuid: type === 'M' ? obj[key].moduleGuid : null,
        folderGuid: type === 'F' ? obj[key].folderGuid : null,
        entityGuid: type === 'E' ? obj[key].entityGuid : null,
        path: type === 'P' ? obj[key].path : null,
        sortOrder: this.selectedNavItem.subItems?.length
          ? Math.max(...this.selectedNavItem.subItems.map(i => i.sortOrder)) + 1
          : 1,
      }));
    },
    filterSelected(list) {
      // Remove already selected items from the dropdown list
      return list.filter((item) => !this.selectedNavItem?.subItems?.some((sub) => sub.id === item.id));
    },
    handleSelect(selectedItem) {
      if(!this.selectedNavItem.subItems){
        this.selectedNavItem.subItems = [];
      }
    },
    async reorder(e) {
      if (this.selectedNavItem.subItems && Array.isArray(this.selectedNavItem.subItems)) {
        this.selectedNavItem.subItems.forEach((subItem, subIndex) => {
          subItem.sortOrder = subIndex + 1;
        });
      }
    },
  },
};
</script>
<style scoped lang="scss">
.legend {
  display: flex;
  justify-content: space-around;
  padding: 10px;
  padding-bottom: 0;
  margin-top: 12px;
  border-top: 1px solid #ddd;

  .legend-item {
    display: flex;
    align-items: center;
    gap: 5px;
  }

  .badge {
    width: 15px;
    height: 15px;
    display: inline-block;
    border-radius: 50%;
  }

  .badge.M {
    background-color: #007bff;
  }

  .badge.F {
    background-color: #28a745;
  }

  .badge.E {
    background-color: #ffc107;
  }

  .badge.P {
    background-color: #6c757d;
  }
}

.content-wrapper {
  padding-top: 10px;
  display: grid;
  grid-template-rows: auto 1fr auto;
  grid-template-columns: 1fr;
}
.custom-option {
  display: flex;
  align-items: center;
  gap: 8px;
}
.sub-items-list{
  height: 61vh;
  overflow-y: auto;
  border: 1px solid #eee;
  padding: 8px;
}
</style>